export default __webpack_public_path__ + "static/media/vitiligo-front.5cab885b.JPG";